import { render, staticRenderFns } from "./ServiceChargeSetup-Biz.vue?vue&type=template&id=09ee9c8e&scoped=true"
import script from "./ServiceChargeSetup-Biz.vue?vue&type=script&lang=js"
export * from "./ServiceChargeSetup-Biz.vue?vue&type=script&lang=js"
import style0 from "./ServiceChargeSetup-Biz.vue?vue&type=style&index=0&id=09ee9c8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ee9c8e",
  null
  
)

export default component.exports